import axios from 'axios';
import router from '@/router';
const request = axios.create({
    // baseURL: 'http://kingshaohui.com:7001',
    // baseURL: 'http://192.168.1.220:8089/appspbcn',//本地
    // baseURL: 'http://192.168.1.250:8088/spbcnapp',
    baseURL: 'https://dev.spbcn.org/spbcnapp/',//正式
    // baseURL: 'https://dev.spbcn.org/appspbcn/',//测试
    // baseURL:'/api',
    timeout: 8000,
});

// 添加请求拦截器
request.interceptors.request.use( 
    function (config) {
        // 在发送请求之前做些什么
        return {
            ...config,
            // headers: {
            // ...config.headers,
            // authorization: window.sessionStorage.getItem('token')
            // }
        }
    },
    function (error) {
        console.log('请求出错了')
        // 对请求错误做些什么
        return Promise.reject(error)
    })

// 添加响应拦截器
request.interceptors.response.use(
    function (response) {
        // 对响应数据做点什么
        return response.data;
    },
    function (error) {
        console.log('响应失败了');
        const response = error.response;
        const status = response.status;

        if (status < 500) {
            switch (status) {
                case 401:
                    router.push({ path: '/' });
                    break;
                case 422:
                    alert(response.data.message);
                    break;
                default:
                    alert('服务器繁忙请稍后重试');
            }
        } else {
            alert('服务器错误请稍后重试');
        }
        console.log(status);
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default {
    get(url, data) {
        return request.get(url, {
            params: data
        })
    },
    post(url, data) {
        return request.post(url, data)
    },
    delete(url, data) {
        return request.delete(url, data)
    },
    put(url, data) {
        return request.put(url, data)
    }
}


// WEBPACK FOOTER //
// ./src/utils/request.js